// Translated display name of an Elakay role. ONE role vocabulary for every screen: it reuses the
// h_dsw_role_* keys already used by Swiper Access Settings (dynamicSwipers/SwiperAccessSettingsPanel)
// instead of a second role dictionary. The technical role value itself is never changed.
import { elakayAutoText } from "../includes/pageInside/dataElakay";

const ROLE_TEXT = {
  user: ["h_dsw_role_user", "User"],
  royalty: ["h_dsw_role_royal", "Royal User"],
  royaluser: ["h_dsw_role_royal", "Royal User"],
  royal: ["h_dsw_role_royal", "Royal User"],
  seller: ["h_dsw_role_seller", "Seller"],
  selleradmin: ["h_dsw_role_seller", "Seller"],
  provider: ["h_dsw_role_provider", "Provider"],
  associate: ["h_dsw_role_associate", "Associate"],
  investment: ["h_dsw_role_investor", "Investor"],
  investor: ["h_dsw_role_investor", "Investor"],
  administrator: ["h_dsw_role_administrator", "Administrator"],
  admin: ["h_dsw_role_administrator", "Administrator"],
  family: ["h_dsw_role_family", "Developer"],
  referrer: ["h_role_referrer", "Referrer"],
  promotion: ["h_role_promotion", "Promotion"],
  unknown: ["h_role_unknown", "Unknown"],
};

const normalize = (role) => String(role || "").replace(/[\s_-]+/g, "").toLowerCase();

export const roleDisplayLabel = (role, fallback) => {
  const entry = ROLE_TEXT[normalize(role)];
  if (entry) return elakayAutoText(...entry);
  return fallback ?? (role || "");
};

// Converts role names embedded in user-facing API messages without changing
// the technical values carried by requests, permissions or stored records.
export const roleDisplayText = (value) => {
  const text = String(value || "");
  const developer = roleDisplayLabel("Family", "Developer");
  return text
    .replace(/\bWorld\s+(?:Family|Familly|Famille)\b/gi, `World ${developer}`)
    .replace(/\b(?:Family|Familly|Famille)\b/gi, developer);
};

export default roleDisplayLabel;
